<div class="header-container">
  <app-header text="{{ 'PROFILE.CONFIGURATION.TITLE' | translate }}"></app-header>
</div>

<main class="content-container">
  <div class="grid-fixed">
    <div class="row">
      <div class="col" size="12" size-md="8" offset-md="2">
        <div class="content">
          <app-title-section text="{{ 'PROFILE.CONFIGURATION.TITLE' | translate }}"></app-title-section>
        </div>
      </div>
    </div>
  </div>
  <div class="grid-fixed">
    <div class="row">
      <div class="col" size="10" size-md="8" offset-md="2">
        <h5 class="u-h5">{{ 'PROFILE.CONFIGURATION.OFFICE_SERVICES' | translate }}</h5>
      </div>
      <div class="col" size="2">
        <app-toggle [checked]="infoBoolean" (toggleChange)="checkChange($event)"></app-toggle>
      </div>
    </div>
    <div class="row">
      <div class="col" size="12" offset-md="2">
        <p class="u-p3 u-medium-grey">{{ 'PROFILE.CONFIGURATION.OFFICE_SERVICES_INFO' | translate }}</p>
      </div>
    </div>
  </div>
</main>
